@if (sponsor()?.image_url) {
    <a target="_blank" class="sponsor-banner" (click)="postEvent()" [attr.data-analytics-sponsor-url]="sponsor()?.url">
        <figure>
            <img [src]="imageSrc" alt="sponsor banner" [style.aspect-ratio]="imageAspectRatio" />
        </figure>
    </a>
}
